export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-US", {
      month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const todayStr = () => new Date().toISOString().slice(0, 10);

export const PAYMENT_LABELS = {
  cash: "Cash",
  credit: "Credit / Debit",
  split: "Split",
  website: "Website",
  doordash: "DoorDash",
  prize: "Prize",
};

export const gradient = "bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600";
export const gradientText =
  "bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-purple-600";
